import { bind } from 'bind-decorator';
import Moment from 'moment';
import React from 'react';
import { colours } from '../../../../../../styles/colours';
import Picker from '../../../../../form/field/field-time-picker';
import OutlineButton from '../../../../../general/outline-button';

interface IProps {
  errored: boolean;
  warning: boolean;
  value?: null | string;

  onChange: (value: string) => void;
}

class TimePicker extends React.Component<IProps> {
  static defaultProps: Partial<IProps> = {
    onChange: () => null
  };

  picker: React.RefObject<any> = React.createRef();

  shouldComponentUpdate(nextProps: IProps): boolean {
    const { props } = this;

    if (props.errored !== nextProps.errored) {
      return true;
    }

    if (props.warning !== nextProps.warning) {
      return true;
    }

    if (props.value !== nextProps.value) {
      return true;
    }

    return false;
  }

  render() {
    const { errored, warning, value } = this.props;
    const style = { minWidth: '100px' }; // {background:'#DDEAF6', borderColor:'#B6D3EC'}

    if (errored) {
      style.background = colours.red200;
      style.background = colours.red400;
      style.color = `${colours.red} !important`;
    } else if (warning && value == null) {
      style.background = colours.orange100;
      style.borderColor = colours.orange300;
      style.color = `${colours.orange300} !important`;
    }

    const textFieldStyle = { display: 'none' };
    const display = value != null ? Moment(value).format('h:mm a') : 'Select Time';

    return (
      <React.Fragment>
        <OutlineButton onClick={this.open} style={style}>
          {display}
        </OutlineButton>
        <Picker
          ref={this.picker}
          id={'time-picker'}
          style={textFieldStyle}
          value={value}
          onChange={this.onChange}
        />
      </React.Fragment>
    );
  }

  @bind
  public open(): void {
    const { picker } = this;
    if (!!picker.current) {
      picker.current.onOpen();
    }
  }

  @bind
  private onChange(dateTime: string) {
    let formattedTime = Moment(dateTime).format('YYYY-MM-DDTHH:mm:ss');
    this.props.onChange(formattedTime);
  }
}

export default TimePicker;
